import { LocationItem } from '../../../../services/location.service';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Returns true when the value is a UUID usable by location APIs. */
export function isLocationUuid(value: unknown): boolean {
  return typeof value === 'string' && UUID_REGEX.test(value.trim());
}

/** Resolves a location dropdown value to an item id (by id or case-insensitive name). */
export function resolveLocationItemId(
  items: LocationItem[],
  raw: unknown,
): string | null {
  const value = String(raw ?? '').trim();
  if (!value) {
    return null;
  }
  if (isLocationUuid(value)) {
    return value;
  }
  const lower = value.toLowerCase();
  const match = items.find((item) => item.name?.trim().toLowerCase() === lower);
  return match?.id ?? null;
}
